import {clearString, FullAlphabet} from "../helpers/stringHelpers";

const cachedMobile = {};
const Mobile = {
    aplhabet: function (missing) {
        let mergedMissing = missing.join('');
        if (cachedMobile[mergedMissing]) {
            return cachedMobile[mergedMissing]
        }
        let myAlphabet = FullAlphabet.filter((str) => {
            return missing.every((a)=>{
                return str !== a.toLowerCase().replace('ch', '*')
            })
            // return str !== missing[0].toLowerCase().replace('ch', '*') &&
            //     str !== missing[1].toLowerCase().replace('ch', '*') &&
            //     str !== missing[2].toLowerCase().replace('ch', '*')
        });
        let processedAlphabet = {}
        // myAlphabet.forEach((char)=>{
            processedAlphabet['2'] = myAlphabet[0];
            processedAlphabet['22'] = myAlphabet[1];
            processedAlphabet['222'] = myAlphabet[2];
            processedAlphabet['3'] = myAlphabet[3];
            processedAlphabet['33'] = myAlphabet[4];
            processedAlphabet['333'] = myAlphabet[5];
            processedAlphabet['4'] = myAlphabet[6];
            processedAlphabet['44'] = myAlphabet[7];
            processedAlphabet['444'] = myAlphabet[8];
            processedAlphabet['5'] = myAlphabet[9];
            processedAlphabet['55'] = myAlphabet[10];
            processedAlphabet['555'] = myAlphabet[11];
            processedAlphabet['6'] = myAlphabet[12];
            processedAlphabet['66'] = myAlphabet[13];
            processedAlphabet['666'] = myAlphabet[14];
            processedAlphabet['7'] = myAlphabet[15];
            processedAlphabet['77'] = myAlphabet[16];
            processedAlphabet['777'] = myAlphabet[17];
            processedAlphabet['7777'] = myAlphabet[18];
            processedAlphabet['8'] = myAlphabet[19];
            processedAlphabet['88'] = myAlphabet[20];
            processedAlphabet['888'] = myAlphabet[21];
            processedAlphabet['9'] = myAlphabet[22];
            processedAlphabet['99'] = myAlphabet[23];
            processedAlphabet['999'] = myAlphabet[24];
            processedAlphabet['9999'] = myAlphabet[25];
            processedAlphabet[myAlphabet[0]] ='2';
            processedAlphabet[myAlphabet[1]] ='22';
            processedAlphabet[myAlphabet[2]] ='222';
            processedAlphabet[myAlphabet[3]] ='3';
            processedAlphabet[myAlphabet[4]] ='33';
            processedAlphabet[myAlphabet[5]] ='333';
            processedAlphabet[myAlphabet[6]] ='4';
            processedAlphabet[myAlphabet[7]] ='44';
            processedAlphabet[myAlphabet[8]] ='444';
            processedAlphabet[myAlphabet[9]] ='5';
            processedAlphabet[myAlphabet[10]]='55' ;
            processedAlphabet[myAlphabet[11]]='555' ;
            processedAlphabet[myAlphabet[12]]='6' ;
            processedAlphabet[myAlphabet[13]]='66' ;
            processedAlphabet[myAlphabet[14]]='666' ;
            processedAlphabet[myAlphabet[15]]='7' ;
            processedAlphabet[myAlphabet[16]]='77' ;
            processedAlphabet[myAlphabet[17]]='777' ;
            processedAlphabet[myAlphabet[18]]='7777' ;
            processedAlphabet[myAlphabet[19]]='8' ;
            processedAlphabet[myAlphabet[20]]='88' ;
            processedAlphabet[myAlphabet[21]]='888' ;
            processedAlphabet[myAlphabet[22]]='9' ;
            processedAlphabet[myAlphabet[23]]='99' ;
            processedAlphabet[myAlphabet[24]]='999' ;
            processedAlphabet[myAlphabet[25]]='9999' ;
        // })
        cachedMobile[mergedMissing] = processedAlphabet;
        return cachedMobile[mergedMissing];
        // return myAlphabet;
    }
}

const SEPARATOR = ' '
export const methods = {
    cypher: function (input, hasCh=false, missing = ['ch'], params, sep = SEPARATOR) {
        let cyphered = []
        let cleared = clearString(input, !missing.includes('ch'))//.replaceAll(/[ ]/g,'')
        missing.forEach((char)=>{
            if(char!=='ch')
                cleared = cleared.replaceAll(char,'')
        })
        let characters = cleared.split('');//.forEach((char)=>{ });
        for (let i = 0; i < characters.length; i++){
            let char = characters[i];
            if(char.match(/[.,?! ]/)){
                cyphered.push(char);
            }else{
                let foundA = Mobile.aplhabet(missing);
                let chr = foundA[characters[i]]
                cyphered.push(chr);
            }

        }

        return cyphered.join(sep)
            .replaceAll('*','ch')
    },
    decypher: function (input, hasCh=false, missing = ['ch'], params) {
        let deciphered = []

        let characters = input.replaceAll(/ {2}/g,' ').split(SEPARATOR);//.forEach((char)=>{ });
        for (let i = 0; i < characters.length; i++){
            let char = characters[i];
            if(char.match(/[.,?! ]/)){
                deciphered.push(char);
            }else if(char.length==0){
                deciphered.push(' ');
            }else{
                let foundA = Mobile.aplhabet(missing);
                let chr = foundA[characters[i]]
                deciphered.push(chr);
            }

        }
        return deciphered.join('')
    },
};

export default {...methods,SEPARATOR}